module.exports = __webpack_public_path__ + "img/padlock.f16130a8.svg";